import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postUserCoupon } from "src/api/coupon";
export const useDownloadCouponMutation = (param)=>{
    let { authorId  } = param;
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (couponId)=>postUserCoupon(couponId),
        onSuccess: ()=>{
            // 쿠폰 다운로드 성공 시 해당 저자의 쿠폰 목록 갱신
            queryClient.invalidateQueries({
                queryKey: [
                    "authorCoupons",
                    authorId
                ]
            });
        }
    });
};
